<div class="card-base">
    <div class="card-content-operation">
        <div class="card-container mat-elevation-z1">
            <div class="card-content">
                <form [formGroup]="form">
                    <app-medical-order-operation-control-component formControlName="MedicalOrderOperation">
                    </app-medical-order-operation-control-component>
                </form>
            </div>
        </div>
    </div>
</div>